import React from 'react';
import classNames from 'classnames'

export const PoiMarker = ({ category, active, className }) => {
  const iconName = category?.name || '';

  const hex2rgba = (hex, alpha = 0.6) => {
    if (!hex) return `rgba(0,0,0,${alpha})`;
    const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
  };

  var activeShadow = active ? `0 0 0 4px ${hex2rgba(category?.color)}` : '';

  return (
    <div className={classNames('relative flex justify-center items-center', className)}>
      <span
        className="w-7 h-7 border-2 border-white inline-block rounded-bl-full rounded-t-full rotate-45 shadow"
        style={{
          background: category?.color,
          boxShadow: activeShadow,
        }}
      ></span>
      <span className={`gys gys-${iconName} absolute top-1/2 left-1/2 z-10 text-white text-base -translate-x-1/2 -translate-y-1/2`}></span>
    </div>
  );
};

export default PoiMarker;
